import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#fff'
        d='M7.333 7.333v-4h1.334v4h4v1.334h-4v4H7.333v-4h-4V7.334h4z'
      ></path>
    </svg>
  )
}

export default Icon
